import React from 'react';
import { AwardIcon, CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { productBrand, productEdition, totalBonuses, totalVolumes } from '../data/offer';
export function SystemSection() {
  return <section className="border-y border-slate-200 bg-slate-50 py-16 sm:py-20" aria-labelledby="system-title" data-id="element-185" data-mp="3bhbu9hm7k3fw">
      <div className="mx-auto max-w-4xl px-4 text-center" data-id="element-186" data-mp="36jjzmfu6i380">
        <span className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-xs font-medium text-slate-700" data-id="element-187" data-mp="31lqyi17qfzel">
          <AwardIcon className="h-4 w-4 shrink-0 text-amber-600" aria-hidden="true" data-id="element-188" data-mp="2ws5wly30qla4" /> The Complete Vendor-Neutral Process Control & SCADA Systems Professional Reference
        </span>
        <SectionHeading id="system-title" className="mt-6" data-id="element-189" data-mp="2nv5bc0b8x3aw">
          {productBrand} — <span className="text-teal-700" data-id="element-190" data-mp="2iswid3ydi18s">{productEdition}</span>
        </SectionHeading>
        <p className="mt-4 font-medium text-slate-600" data-id="element-191" data-mp="2dw63gjyb1boy">
          {totalVolumes} volumes · {totalBonuses} exclusive bonuses
        </p>

        <p className="mx-auto mt-10 flex max-w-3xl items-start gap-3 rounded-xl border border-slate-200 bg-white p-6 text-left text-lg font-medium leading-relaxed text-slate-900 shadow-sm" data-id="element-192" data-mp="13x4xrxpipf80">
          <CheckIcon className="mt-1 h-6 w-6 shrink-0 text-teal-700" aria-hidden="true" data-id="element-193" data-mp="u2v50ewnyewr" />
          A complete visual technical reference to understand how process plants are controlled and supervised: how
          control loops and PID work, how DCS and SCADA systems are built, how field data travels over industrial
          networks, and how professionals operate, protect and troubleshoot control systems safely.
        </p>
      </div>
    </section>;
}